<template>
  <el-dialog
    :close-on-click-modal="false"
    title="驾驶证上传"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section>
      <el-alert
        :closable="false"
        title="温馨提示：针对未上传驾驶证照片的司机，请将他们的驾驶证正本的照片打成一个压缩包，压缩包格式支持：RAR、ZIP，图片格式支持：BMP、JPG、GIF、PNG"
        type="warning"
      />
      <img class="tmplImg" src="~images/archives/driverLicensePic.png" />
      <div class="btnBox">
        导入文件：
        <el-button @click="chooseFile">选择文件</el-button>
      </div>
      <div class="filename" v-if="fileData">{{fileData.name}}</div>
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="sub" :loading="subLoading">上传</el-button>
    </section>
  </el-dialog>
</template>

<script>
import {
  importPost,
} from 'api';
export default {
  data () {
    return {
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      fileData: null,
    };
  },
  methods: {

    downloadTmpl (url) {
      window.open(url);
    },

    chooseFile () {
      let domInput = document.createElement('input');
      domInput.setAttribute('type', 'file'); // 设置为上传文件
      domInput.setAttribute('accept', 'xlsx'); // 限制选择的文件
      domInput.setAttribute('multiple', false); // 设置可否为多选
      domInput.onchange = async () => {
        this.fileData = domInput.files[0];
        domInput = null;
      };
      domInput.click();
    },

    /**
     * @param {Object} arr 数组id
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (arr) {
      this.dialogFormVisible = true; // 打开弹窗
      this.fileData = null;
      this.originData = arr;
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub () {
      importPost({
        data: {
          bizCodes: 'imp1000110',
          file: this.fileData,
        },
        fileData: {
          bizCode: 'imp1000110',
          bizName: '驾驶证正本导入',
          id: 68,
          otherParam: {
            bizCode: 'imp1000110',
          },
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .el-alert__content{
  line-height: 24px;
}
.tmplImg{
  width: 100%;
  margin-bottom: 16px;
}
.tmplFile{
  margin-bottom: 16px;
  color: #999;
}
.btnBox{
  color: #999;
  margin-bottom: 16px;
}
.filename{
  color: #999;
  padding-left: 72px;
}
</style>
